import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

export interface FrontrowMDClinicianAIProps {
  id: string;
}

export const FrontrowMDClinicianAI = ({ id }: FrontrowMDClinicianAIProps) => {
  useEffect(() => {
    if (!id) return;

    const existing = Array.from(
      document.head.querySelectorAll<HTMLScriptElement>(
        'script[data-frontrow-product-id][data-frontrow-presentation="gpt"]',
      ),
    );
    if (existing.some((el) => el.dataset.frontrowProductId === id)) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.dataset.frontrowProductId = id;
    script.dataset.frontrowPresentation = 'gpt';
    script.src = `https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=gpt&product_id=${encodeURIComponent(id)}`;

    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id]);

  return (
    <Box id="frontrow-gpt-container">
      <Box
        as="iframe"
        title="frontrow-clinician-ai"
        id="iframe-frontrow-gpt"
        className="iframe-frontrow-gpt"
        frameBorder="0"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        src={`https://app.thefrontrowhealth.com/api/widgets?presentation_type=gpt&product_id=${encodeURIComponent(id)}`}
        sx={{
          '#iframe-frontrow-gpt, .iframe-modal-frontrow-gpt': {
            display: 'none',
          },
        }}
      />
    </Box>
  );
};
